import { TRADITION_LABELS, type Tradition } from '../theme/tokens';

interface MainPracticePickerProps {
  options: Tradition[];
  selected: Tradition | null;
  onChange: (tradition: Tradition) => void;
}

/** Single-select among the user's already-chosen traditions -- which one leads on Home
 * (featured quote, mascot greeting) when more than one is selected. */
export function MainPracticePicker({ options, selected, onChange }: MainPracticePickerProps) {
  return (
    <div className="main-practice-list">
      {options.map((t) => (
        <button
          key={t}
          type="button"
          className={`main-practice-option${selected === t ? ' selected' : ''}`}
          onClick={() => onChange(t)}
          aria-pressed={selected === t}
        >
          <span className={`main-practice-radio${selected === t ? ' checked' : ''}`} aria-hidden="true" />
          <span>{TRADITION_LABELS[t] ?? t}</span>
        </button>
      ))}
    </div>
  );
}
